import Vue from 'vue';
let Bus = new Vue();
export default Bus;
